import React from "react";
import playicon from "../Image/playicon.png";
import bannerimg from "../Image/Girl.png";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import { Navigation, Autoplay } from "swiper/modules";
import slider1 from "../Image/slider1.png";
import slider2 from "../Image/slider2.png";
import slider3 from "../Image/slider3.png";
import rightArrow from "../Image/right-arrow.png";
import { Container, Row, Col, Button } from "react-bootstrap";

function HeroSection() {
  return (
    <div className="hero-section">
      <div className="hero-wrapper">
        <div className="container">
          <div className="hero-row d-flex align-items-center">
            <div className="text-section">
              <h1>
                Leading <span>Crypto Casino</span>
              </h1>

              <p>
                Enjoy 5000+ crypto games, fast payouts and 24/7 live support.
                Make the best of the superior Bitcoin Casino.
              </p>

              <button className="play-btn">
                <img src={playicon} alt="logo" />
                Play Game
              </button>
            </div>

            <div className="image-section"></div>
          </div>

          <div className="swiper-content">
            <Swiper
              modules={[Navigation, Autoplay]}
              autoplay={{
                delay: 2500,
              }}
              navigation={true}
              spaceBetween={20}
              breakpoints={{
                0: {
                  slidesPerView: 1,
                },
                768: {
                  slidesPerView: 2,
                },
                992: {
                  slidesPerView: 3,
                },
              }}
              className="mySwiper"
            >
              <SwiperSlide>
                <div className="card-box">
                  <img src={slider1} alt="" />
                  <div className="overlay">
                    <h2>
                      Win Real Crypto <br /> by Free Play
                    </h2>
                    <p>
                      Earn extra bonuese from <br />
                      crypto deposits.
                    </p>
                    <div className="arrow-btn">
                      <img src={rightArrow} alt="" />
                    </div>
                  </div>
                </div>
              </SwiperSlide>

              <SwiperSlide>
                <div className="card-box">
                  <img src={slider2} alt="" />
                  <div className="overlay">
                    <h2>
                      Cashback <br /> upto 25%
                    </h2>
                    <p>
                      The more you play, the <br /> more you earn!
                    </p>
                    <div className="arrow-btn">
                      <img src={rightArrow} alt="" />
                    </div>
                  </div>
                </div>
              </SwiperSlide>

              <SwiperSlide>
                <div className="card-box">
                  <img src={slider3} alt="" />
                  <div className="overlay">
                    <h2>Rackback</h2>
                    <p>
                      Earn extra bonuese from <br />
                      inviting friends
                    </p>
                    <div className="arrow-btn" style={{ marginTop: "40px" }}>
                      <img src={rightArrow} alt="" />
                    </div>
                  </div>
                </div>
              </SwiperSlide>

              <SwiperSlide>
                <div className="card-box">
                  <img src={slider1} alt="" />
                  <div className="overlay">
                    <h2>
                      Win Real Crypto <br /> by Free Play
                    </h2>
                    <p>
                      Earn extra bonuese from <br />
                      crypto deposits.
                    </p>
                    <div className="arrow-btn">
                      <img src={rightArrow} alt="" />
                    </div>
                  </div>
                </div>
              </SwiperSlide>

              <SwiperSlide>
                <div className="card-box">
                  <img src={slider2} alt="" />
                  <div className="overlay">
                    <h2>
                      Cashback <br /> upto 25%
                    </h2>
                    <p>
                      The more you play, the <br /> more you earn!
                    </p>
                    <div className="arrow-btn">
                      <img src={rightArrow} alt="" />
                    </div>
                  </div>
                </div>
              </SwiperSlide>

              <SwiperSlide>
                <div className="card-box">
                  <img src={slider3} alt="" />
                  <div className="overlay">
                    <h2>Rackback</h2>
                    <p>
                      Earn extra bonuese from <br />
                      inviting friends
                    </p>
                    <div className="arrow-btn" style={{ marginTop: "40px" }}>
                      <img src={rightArrow} alt="" />
                    </div>
                  </div>
                </div>
              </SwiperSlide>
            </Swiper>
          </div>
        </div>
      </div>
    </div>
  );
}

export default HeroSection;
